export class SituacaoSorteioModel {

    public codSituacaoSorteioPremiacaoConsumidor: number;
    public desSituacaoSorteioPremiacaoConsumidor: string;
    public dataAtualizacao: Date;

    public ATUAL: number = 1;
    public AREALIZAR: number = 2;
    public REALIZADO: number = 3;
    public HOMOLOGADO: number = 4;
}



// WEBPACK FOOTER //
// ./src/app/shared/model/situacao-sorteio.model.ts